import Vue from 'vue';
import Router from 'vue-router';
import ListContact from '@/components/ListContact';
import ListChat from '@/components/ListChat';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: __dirname, // eslint-disable-line
  routes: [
    {
      path: '/',
      redirect: { name: 'ListContact' },
    },
    {
      path: '/Contact',
      name: 'ListContact',
      component: ListContact,
    },
    {
      path: '/Chat',
      name: 'ListChat',
      component: ListChat,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js